export const PilotActionsConstants = {
    play: "PLAY",
    pause: "PAUSE",
    stop: "STOP",
    changeMedia: "CHANGE_MEDIA",
    mute: "MUTE",
    unmute: "UNMUTE"
}
